module.exports = __webpack_public_path__ + "static/media/bgVideo.c8cb8f57.mp4";